export const FilmSlateLoader = ({ message = "Rolling…" }) => (
  <div
    data-testid="film-slate-loader"
    className="fixed inset-0 z-[200] grid place-items-center bg-[#050505]"
  >
    <style>{`
      @keyframes nv-clap {
        0%, 55%, 100% { transform: rotate(0deg); }
        25% { transform: rotate(-32deg); }
      }
      @keyframes nv-float {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(-6px); }
      }
      @keyframes nv-fade { from { opacity: 0; } to { opacity: 1; } }
      .nv-clapper { transform-box: fill-box; transform-origin: 4px bottom; animation: nv-clap 1.5s cubic-bezier(.6,0,.2,1) infinite; }
      .nv-slate { animation: nv-float 3s ease-in-out infinite; }
      .nv-loader-fade { animation: nv-fade .4s ease-out both; }
    `}</style>

    <div className="nv-loader-fade flex flex-col items-center gap-7">
      <div className="nv-slate">
        <svg width="132" height="122" viewBox="0 0 132 122" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* hinged clapper */}
          <g className="nv-clapper">
            <rect x="6" y="4" width="120" height="22" rx="4" fill="#0a0a0a" stroke="#00F0FF" strokeWidth="2.5" />
            <path d="M14 26 L26 6 L40 6 L28 26 Z" fill="#f5f5f5" />
            <path d="M50 26 L62 6 L76 6 L64 26 Z" fill="#f5f5f5" />
            <path d="M86 26 L98 6 L112 6 L100 26 Z" fill="#f5f5f5" />
          </g>
          {/* slate body */}
          <rect x="8" y="34" width="116" height="82" rx="6" fill="#0d0d0d" stroke="#00F0FF" strokeWidth="2.5" />
          <rect x="22" y="52" width="76" height="6" rx="3" fill="#00F0FF" opacity="0.85" />
          <rect x="22" y="68" width="52" height="6" rx="3" fill="#ffffff" opacity="0.25" />
          <rect x="22" y="84" width="64" height="6" rx="3" fill="#ffffff" opacity="0.18" />
        </svg>
      </div>

      <div className="flex items-center gap-2.5">
        <span className="h-2 w-2 rounded-full bg-[#00F0FF] animate-pulse" />
        <p className="text-white/70 text-sm tracking-wide font-medium">{message}</p>
      </div>
    </div>
  </div>
);
